import type { ElementType } from "react";
import { BaseButton } from "./index";
import type { ButtonProps } from "./types";

export const Button = <C extends ElementType = "button">(
  props: ButtonProps<C>,
) => {
  const displayContent = props.children || props.content;
  const textContent = typeof displayContent === "string" ? displayContent : "";

  return (
    <BaseButton<C>
      {...props}
      isIcon={false}
      aria-label={props["aria-label"] || textContent || "Button"}
    >
      {displayContent}
    </BaseButton>
  );
};
